export default __webpack_public_path__ + "static/media/firebaseorg.0cdfe2bd.png";